import { TFunction } from 'i18next'
import MssqlPolicyRestService from '../rest/MssqlPolicyRestService'

class MssqlPolicyService {
  static async getStatus() {
    return MssqlPolicyRestService.getStatus()
  }

  static async applyPolicy(t: TFunction) {
    try {
      const noOfTasks: any = await MssqlPolicyRestService.applyPolicy()
      return t('mssqlAdapter.applyPolicySuccess', { noOfTasks: noOfTasks?.numberOfTasks })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async unapplyPolicy(t: TFunction) {
    try {
      const noOfTasks: any = await MssqlPolicyRestService.unapplyPolicy()
      return t('mssqlAdapter.unapplyPolicySuccess', { noOfTasks: noOfTasks?.numberOfTasks })
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default MssqlPolicyService
